/*
 * Teasery produktu i kolekcji osadzane w tresci artykulu bloga.
 *
 * Placeholdery (wstawiane recznie w widoku HTML wpisu):
 *
 *   Produkt (ze sliderem zdjec, cena live):
 *   <div class="product-teaser"
 *        data-handle="handle-produktu"
 *        data-variant="dark"      (dark | light, domyslnie light)
 *        data-variant-id="123456" (opcjonalnie: ID konkretnego wariantu -
 *                                   karta pokaze WYLACZNIE jego zdjecie i cene,
 *                                   a linki poprowadza na ?variant=ID)
 *        data-caption="Opis kontekstowy, max 6 wierszy">
 *     <a href="/products/handle-produktu">Nazwa produktu</a>
 *   </div>
 *
 *   Kolekcja (jedno zdjecie kolekcji, bez ceny):
 *   <div class="collection-teaser"
 *        data-handle="handle-kolekcji"
 *        data-variant="light"
 *        data-caption="Opis kontekstowy">
 *     <a href="/collections/handle-kolekcji">Nazwa kolekcji</a>
 *   </div>
 *
 * WAZNE - link w srodku placeholdera:
 * Zwykly <a href> wewnatrz <div> jest OBOWIAZKOWY. Karta powstaje dopiero w
 * przegladarce, wiec bez niego w zrodle strony nie ma zadnego linku i Google nie
 * widzi powiazania artykul -> produkt. Link jest widoczny tylko do momentu
 * doladowania karty (ulamek sekundy) i sluzy jednoczesnie jako fallback, gdy JS
 * sie nie wykona.
 *
 * data-variant-id - po co:
 * Domyslnie karta pokazuje glowne, domyslne zdjecie produktu w calym sklepie -
 * to samo zdjecie wszedzie, niezaleznie od artykulu. Jesli produkt ma warianty
 * (np. rozne kolory kamienia) i chcesz w KONKRETNYM artykule pokazac konkretny
 * wariant - dodaj data-variant-id z ID tego wariantu (znajdziesz je np. w URL-u
 * strony produktu po wybraniu wariantu: ?variant=XXXXXXXXXX). Nie zmienia to
 * niczego globalnie w sklepie - dotyczy tylko tej jednej karty.
 *
 * Zasady:
 * - Dane produktu pobierane live z /products/{handle}.js (cena, dostepnosc, zdjecia).
 *   Ten endpoint zwraca tylko 250 wariantow - jesli data-variant-id jest spoza tej
 *   puli, dane wariantu przychodza z /products/{handle}?variant=ID&view=teaser-variant
 *   (szablon product.teaser-variant.liquid).
 * - Dane kolekcji z /collections/{handle}?view=teaser (szablon collection.teaser.liquid).
 * - Handle nie istnieje (404) -> znika caly placeholder razem z linkiem, zeby nie
 *   zostawic w tresci linku prowadzacego do 404.
 * - Inny blad (siec, offline) -> zostaje sam link fallbackowy: produkt istnieje,
 *   wiec lepszy goly link niz nic.
 * - Reserved space (min-height w CSS) minimalizuje CLS.
 */
(function () {
  'use strict';

  var MONEY_FORMAT =
    (window.Shopify && window.Shopify.moneyFormat) ||
    window.blogTeaserMoneyFormat ||
    '{{amount}}';

  var ARROW_SVG =
    '<svg viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M1 1l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    var value;
    switch (format.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function imageUrl(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url.replace(
      /(\.(?:png|jpe?g|webp|gif))(\?.*)?$/i,
      '_' + width + 'x$1$2'
    );
  }

  function esc(s) {
    return (s == null ? '' : String(s))
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function variantOf(el) {
    return el.getAttribute('data-variant') === 'dark' ? 'dark' : 'light';
  }

  function findVariant(product, variantId) {
    if (!variantId || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) {
        return product.variants[i];
      }
    }
    return null;
  }

  function initSlider(root) {
    var track = root.querySelector('.blog-teaser__track');
    var next = root.querySelector('.blog-teaser__arrow--next');
    var prev = root.querySelector('.blog-teaser__arrow--prev');
    if (!track) return;

    function step() {
      var slide = track.querySelector('.blog-teaser__slide');
      return slide ? slide.getBoundingClientRect().width + 8 : track.clientWidth;
    }
    function update() {
      if (prev) prev.hidden = track.scrollLeft < 5;
      if (next) {
        next.hidden =
          track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
      }
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  function buildProduct(el, product, extraVariant) {
    var variant = variantOf(el);
    var caption = el.getAttribute('data-caption') || '';
    var variantId = el.getAttribute('data-variant-id') || '';
    var pickedVariant = findVariant(product, variantId) || extraVariant || null;

    var productUrl = product.url;
    if (pickedVariant) {
      productUrl += (productUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(pickedVariant.id);
    }

    var gallery = el.getAttribute('data-gallery') !== 'false';
    var allImages;
    if (pickedVariant) {
      var variantImg =
        (pickedVariant.featured_image && pickedVariant.featured_image.src) ||
        null;
      allImages = variantImg
        ? [variantImg]
        : product.images && product.images.length
        ? product.images
        : product.featured_image
        ? [product.featured_image]
        : [];
    } else {
      allImages =
        product.images && product.images.length
          ? product.images
          : product.featured_image
          ? [product.featured_image]
          : [];
    }
    var images = pickedVariant ? allImages.slice(0, 1) : gallery ? allImages : allImages.slice(0, 1);
    var single = images.length <= 1;

    var slides = images
      .map(function (src) {
        return (
          '<div class="blog-teaser__slide"><img src="' +
          imageUrl(src, 740) +
          '" alt="' +
          esc(product.title) +
          '" loading="lazy"></div>'
        );
      })
      .join('');

    var arrows = single
      ? ''
      : '<button type="button" class="blog-teaser__arrow blog-teaser__arrow--prev" aria-label="Poprzednie zdjecie" hidden>' +
        ARROW_SVG +
        '</button>' +
        '<button type="button" class="blog-teaser__arrow blog-teaser__arrow--next" aria-label="Nastepne zdjecie">' +
        ARROW_SVG +
        '</button>';

    var priceValue = pickedVariant ? pickedVariant.price : product.price;
    var price =
      priceValue != null
        ? '<p class="blog-teaser__price">' +
          formatMoney(priceValue, MONEY_FORMAT) +
          '</p>'
        : '';

    var root = document.createElement('div');
    root.className = 'blog-teaser blog-teaser--product blog-teaser--' + variant;
    root.innerHTML =
      '<div class="blog-teaser__media' +
      (single ? ' blog-teaser__media--single' : '') +
      '"><div class="blog-teaser__track">' +
      slides +
      '</div>' +
      arrows +
      '</div>' +
      '<div class="blog-teaser__text">' +
      '<div class="blog-teaser__col blog-teaser__heading">' +
      '<a class="blog-teaser__title" href="' +
      productUrl +
      '">' +
      esc(product.title) +
      '</a>' +
      price +
      '</div>' +
      '<div class="blog-teaser__col"><p class="blog-teaser__caption">' +
      esc(caption) +
      '</p></div>' +
      '</div>' +
      '<a class="blog-teaser__button" href="' +
      productUrl +
      '">Zobacz produkt</a>';

    return root;
  }

  function buildCollection(el, data) {
    if (!data || data.empty || !data.image) return null;
    var variant = variantOf(el);
    var caption = el.getAttribute('data-caption') || '';

    var root = document.createElement('div');
    root.className =
      'blog-teaser blog-teaser--collection blog-teaser--' + variant;
    root.innerHTML =
      '<div class="blog-teaser__media"><a class="blog-teaser__photo" href="' +
      data.url +
      '"><img src="' +
      esc(data.image) +
      '" alt="' +
      esc(data.title) +
      '" loading="lazy"></a></div>' +
      '<div class="blog-teaser__text">' +
      '<div class="blog-teaser__col"><a class="blog-teaser__title blog-teaser__title--accent" href="' +
      data.url +
      '">' +
      esc(data.title) +
      '</a></div>' +
      '<div class="blog-teaser__col"><p class="blog-teaser__caption">' +
      esc(caption) +
      '</p></div>' +
      '</div>' +
      '<a class="blog-teaser__button" href="' +
      data.url +
      '">Zobacz kolekcje</a>';
    return root;
  }

  function NotFound() {}

  function dropPlaceholder(el, keepLink) {
    var link = keepLink ? el.querySelector('a[href]') : null;
    if (link) {
      el.replaceWith(link);
    } else {
      el.remove();
    }
  }

  function renderProduct(el) {
    var handle = el.getAttribute('data-handle');
    if (!handle) return;
    fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (res.status === 404) throw new NotFound();
        if (!res.ok) throw new Error('fetch failed');
        return res.json();
      })
      .then(function (product) {
        // /products/{handle}.js zwraca max 250 wariantow. Wariant spoza tej puli
        // dociagamy z szablonu product.teaser-variant.liquid.
        var variantId = el.getAttribute('data-variant-id') || '';
        if (!variantId || findVariant(product, variantId)) return [product, null];
        return fetch(
          '/products/' + encodeURIComponent(handle) +
            '?variant=' + encodeURIComponent(variantId) + '&view=teaser-variant'
        )
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (data) {
            return [product, data && String(data.id) === String(variantId) ? data : null];
          })
          .catch(function () {
            return [product, null];
          });
      })
      .then(function (result) {
        var card = buildProduct(el, result[0], result[1]);
        el.replaceWith(card);
        initSlider(card);
      })
      .catch(function (err) {
        dropPlaceholder(el, !(err instanceof NotFound));
      });
  }

  function renderCollection(el) {
    var handle = el.getAttribute('data-handle');
    if (!handle) return;
    fetch('/collections/' + encodeURIComponent(handle) + '?view=teaser')
      .then(function (res) {
        if (res.status === 404) throw new NotFound();
        if (!res.ok) throw new Error('fetch failed');
        return res.json();
      })
      .then(function (data) {
        var card = buildCollection(el, data);
        if (card) {
          el.replaceWith(card);
        } else {
          dropPlaceholder(el, true);
        }
      })
      .catch(function (err) {
        dropPlaceholder(el, !(err instanceof NotFound));
      });
  }

  function init() {
    var container =
      document.querySelector('.article-template__content') || document;
    var products = container.querySelectorAll('.product-teaser[data-handle]');
    for (var i = 0; i < products.length; i++) renderProduct(products[i]);
    var collections = container.querySelectorAll(
      '.collection-teaser[data-handle]'
    );
    for (var j = 0; j < collections.length; j++) renderCollection(collections[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
